import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
var r = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function e(r) {
  if (r.__esModule) return r;
  var e = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(r).forEach(function (t) {
    var n = Object.getOwnPropertyDescriptor(r, t);
    Object.defineProperty(e, t, n.get ? n : {
      enumerable: !0,
      get: function get() {
        return r[t];
      }
    });
  }), e;
}
function t(r) {
  var e = {
    exports: {}
  };
  return r(e, e.exports), e.exports;
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function n(r, e, t, n) {
  return new (t || (t = Promise))(function (o, i) {
    function a(r) {
      try {
        c(n.next(r));
      } catch (r) {
        i(r);
      }
    }
    function f(r) {
      try {
        c(n.throw(r));
      } catch (r) {
        i(r);
      }
    }
    function c(r) {
      var e;
      r.done ? o(r.value) : (e = r.value, e instanceof t ? e : new t(function (r) {
        r(e);
      })).then(a, f);
    }
    c((n = n.apply(r, e || [])).next());
  });
}
!function (r) {
  function e() {}
  function t() {}
  var n = String.fromCharCode,
    o = {}.toString,
    i = o.call(r.SharedArrayBuffer),
    a = o(),
    f = r.Uint8Array,
    c = f || Array,
    s = f ? ArrayBuffer : c,
    u = s.isView || function (r) {
      return r && "length" in r;
    },
    h = o.call(s.prototype);
  s = t.prototype;
  var l = r.TextEncoder,
    y = new (f ? Uint16Array : c)(32);
  e.prototype.decode = function (r) {
    if (!u(r)) {
      var e = o.call(r);
      if (e !== h && e !== i && e !== a) throw TypeError("Failed to execute 'decode' on 'TextDecoder': The provided value is not of type '(ArrayBuffer or ArrayBufferView)'");
      r = f ? new c(r) : r || [];
    }
    for (var t, s, l, p = e = "", d = 0, b = 0 | r.length, v = b - 32 | 0, g = 0, w = 0, A = 0, m = -1; d < b;) {
      for (t = d <= v ? 32 : b - d | 0; A < t; d = d + 1 | 0, A = A + 1 | 0) {
        switch ((s = 255 & r[d]) >> 4) {
          case 15:
            if (2 != (l = 255 & r[d = d + 1 | 0]) >> 6 || 247 < s) {
              d = d - 1 | 0;
              break;
            }
            g = (7 & s) << 6 | 63 & l, w = 5, s = 256;
          case 14:
            g <<= 6, g |= (15 & s) << 6 | 63 & (l = 255 & r[d = d + 1 | 0]), w = 2 == l >> 6 ? w + 4 | 0 : 24, s = s + 256 & 768;
          case 13:
          case 12:
            g <<= 6, g |= (31 & s) << 6 | 63 & (l = 255 & r[d = d + 1 | 0]), w = w + 7 | 0, d < b && 2 == l >> 6 && g >> w && 1114112 > g ? (s = g, 0 <= (g = g - 65536 | 0) && (m = 55296 + (g >> 10) | 0, s = 56320 + (1023 & g) | 0, 31 > A ? (y[A] = m, A = A + 1 | 0, m = -1) : (l = m, m = s, s = l))) : (d = d - (s >>= 8) - 1 | 0, s = 65533), g = w = 0, t = d <= v ? 32 : b - d | 0;
          default:
            y[A] = s;
            continue;
          case 11:
          case 10:
          case 9:
          case 8:
        }
        y[A] = 65533;
      }
      if (p += n(y[0], y[1], y[2], y[3], y[4], y[5], y[6], y[7], y[8], y[9], y[10], y[11], y[12], y[13], y[14], y[15], y[16], y[17], y[18], y[19], y[20], y[21], y[22], y[23], y[24], y[25], y[26], y[27], y[28], y[29], y[30], y[31]), 32 > A && (p = p.slice(0, A - 32 | 0)), d < b) {
        if (y[0] = m, A = ~m >>> 31, m = -1, p.length < e.length) continue;
      } else -1 !== m && (p += n(m));
      e += p, p = "";
    }
    return e;
  }, s.encode = function (r) {
    var e,
      t = 0 | (r = void 0 === r ? "" : "" + r).length,
      n = new c(8 + (t << 1) | 0),
      o = 0,
      i = !f;
    for (e = 0; e < t; e = e + 1 | 0, o = o + 1 | 0) {
      var a = 0 | r.charCodeAt(e);
      if (127 >= a) n[o] = a;else {
        if (2047 >= a) n[o] = 192 | a >> 6;else {
          r: {
            if (55296 <= a) if (56319 >= a) {
              var s = 0 | r.charCodeAt(e = e + 1 | 0);
              if (56320 <= s && 57343 >= s) {
                if (65535 < (a = (a << 10) + s - 56613888 | 0)) {
                  n[o] = 240 | a >> 18, n[o = o + 1 | 0] = 128 | a >> 12 & 63, n[o = o + 1 | 0] = 128 | a >> 6 & 63, n[o = o + 1 | 0] = 128 | 63 & a;
                  continue;
                }
                break r;
              }
              a = 65533;
            } else 57343 >= a && (a = 65533);
            !i && e << 1 < o && e << 1 < (o - 7 | 0) && (i = !0, (s = new c(3 * t)).set(n), n = s);
          }
          n[o] = 224 | a >> 12, n[o = o + 1 | 0] = 128 | a >> 6 & 63;
        }
        n[o = o + 1 | 0] = 128 | 63 & a;
      }
    }
    return f ? n.subarray(0, o) : n.slice(0, o);
  }, l || (r.TextDecoder = e, r.TextEncoder = t);
}("" + void 0 == typeof r ? "" + void 0 == typeof self ? r : self : r);
var o = e(Object.freeze({
    __proto__: null,
    default: {}
  })),
  i = t(function (r) {
    !function (r) {
      var e = function e(r) {
          var e,
            t = new Float64Array(16);
          if (r) for (e = 0; e < r.length; e++) t[e] = r[e];
          return t;
        },
        t = function t() {
          throw new Error("no PRNG");
        },
        n = new Uint8Array(16),
        i = new Uint8Array(32);
      i[0] = 9;
      var a = e(),
        f = e([1]),
        c = e([56129, 1]),
        s = e([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]),
        u = e([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]),
        h = e([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]),
        l = e([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]),
        y = e([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
      function p(r, e, t, n) {
        r[e] = t >> 24 & 255, r[e + 1] = t >> 16 & 255, r[e + 2] = t >> 8 & 255, r[e + 3] = 255 & t, r[e + 4] = n >> 24 & 255, r[e + 5] = n >> 16 & 255, r[e + 6] = n >> 8 & 255, r[e + 7] = 255 & n;
      }
      function d(r, e, t, n, o) {
        var i,
          a = 0;
        for (i = 0; i < o; i++) a |= r[e + i] ^ t[n + i];
        return (1 & a - 1 >>> 8) - 1;
      }
      function b(r, e, t, n) {
        return d(r, e, t, n, 16);
      }
      function v(r, e, t, n) {
        return d(r, e, t, n, 32);
      }
      function g(r, e, t, n) {
        !function (r, e, t, n) {
          for (var o, i = 255 & n[0] | (255 & n[1]) << 8 | (255 & n[2]) << 16 | (255 & n[3]) << 24, a = 255 & t[0] | (255 & t[1]) << 8 | (255 & t[2]) << 16 | (255 & t[3]) << 24, f = 255 & t[4] | (255 & t[5]) << 8 | (255 & t[6]) << 16 | (255 & t[7]) << 24, c = 255 & t[8] | (255 & t[9]) << 8 | (255 & t[10]) << 16 | (255 & t[11]) << 24, s = 255 & t[12] | (255 & t[13]) << 8 | (255 & t[14]) << 16 | (255 & t[15]) << 24, u = 255 & n[4] | (255 & n[5]) << 8 | (255 & n[6]) << 16 | (255 & n[7]) << 24, h = 255 & e[0] | (255 & e[1]) << 8 | (255 & e[2]) << 16 | (255 & e[3]) << 24, l = 255 & e[4] | (255 & e[5]) << 8 | (255 & e[6]) << 16 | (255 & e[7]) << 24, y = 255 & e[8] | (255 & e[9]) << 8 | (255 & e[10]) << 16 | (255 & e[11]) << 24, p = 255 & e[12] | (255 & e[13]) << 8 | (255 & e[14]) << 16 | (255 & e[15]) << 24, d = 255 & n[8] | (255 & n[9]) << 8 | (255 & n[10]) << 16 | (255 & n[11]) << 24, b = 255 & t[16] | (255 & t[17]) << 8 | (255 & t[18]) << 16 | (255 & t[19]) << 24, v = 255 & t[20] | (255 & t[21]) << 8 | (255 & t[22]) << 16 | (255 & t[23]) << 24, g = 255 & t[24] | (255 & t[25]) << 8 | (255 & t[26]) << 16 | (255 & t[27]) << 24, w = 255 & t[28] | (255 & t[29]) << 8 | (255 & t[30]) << 16 | (255 & t[31]) << 24, A = 255 & n[12] | (255 & n[13]) << 8 | (255 & n[14]) << 16 | (255 & n[15]) << 24, m = i, E = a, x = f, U = c, _ = s, T = u, S = h, O = l, k = y, M = p, K = d, j = b, B = v, D = g, z = w, P = A, R = 0; R < 20; R += 2) m ^= (o = (B ^= (o = (k ^= (o = (_ ^= (o = m + B | 0) << 7 | o >>> 25) + m | 0) << 9 | o >>> 23) + _ | 0) << 13 | o >>> 19) + k | 0) << 18 | o >>> 14, T ^= (o = (E ^= (o = (D ^= (o = (M ^= (o = T + E | 0) << 7 | o >>> 25) + T | 0) << 9 | o >>> 23) + M | 0) << 13 | o >>> 19) + D | 0) << 18 | o >>> 14, K ^= (o = (S ^= (o = (x ^= (o = (z ^= (o = K + S | 0) << 7 | o >>> 25) + K | 0) << 9 | o >>> 23) + z | 0) << 13 | o >>> 19) + x | 0) << 18 | o >>> 14, P ^= (o = (j ^= (o = (O ^= (o = (U ^= (o = P + j | 0) << 7 | o >>> 25) + P | 0) << 9 | o >>> 23) + U | 0) << 13 | o >>> 19) + O | 0) << 18 | o >>> 14, m ^= (o = (U ^= (o = (x ^= (o = (E ^= (o = m + U | 0) << 7 | o >>> 25) + m | 0) << 9 | o >>> 23) + E | 0) << 13 | o >>> 19) + x | 0) << 18 | o >>> 14, T ^= (o = (_ ^= (o = (O ^= (o = (S ^= (o = T + _ | 0) << 7 | o >>> 25) + T | 0) << 9 | o >>> 23) + S | 0) << 13 | o >>> 19) + O | 0) << 18 | o >>> 14, K ^= (o = (M ^= (o = (k ^= (o = (j ^= (o = K + M | 0) << 7 | o >>> 25) + K | 0) << 9 | o >>> 23) + j | 0) << 13 | o >>> 19) + k | 0) << 18 | o >>> 14, P ^= (o = (z ^= (o = (D ^= (o = (B ^= (o = P + z | 0) << 7 | o >>> 25) + P | 0) << 9 | o >>> 23) + B | 0) << 13 | o >>> 19) + D | 0) << 18 | o >>> 14;
          m = m + i | 0, E = E + a | 0, x = x + f | 0, U = U + c | 0, _ = _ + s | 0, T = T + u | 0, S = S + h | 0, O = O + l | 0, k = k + y | 0, M = M + p | 0, K = K + d | 0, j = j + b | 0, B = B + v | 0, D = D + g | 0, z = z + w | 0, P = P + A | 0, r[0] = m >>> 0 & 255, r[1] = m >>> 8 & 255, r[2] = m >>> 16 & 255, r[3] = m >>> 24 & 255, r[4] = E >>> 0 & 255, r[5] = E >>> 8 & 255, r[6] = E >>> 16 & 255, r[7] = E >>> 24 & 255, r[8] = x >>> 0 & 255, r[9] = x >>> 8 & 255, r[10] = x >>> 16 & 255, r[11] = x >>> 24 & 255, r[12] = U >>> 0 & 255, r[13] = U >>> 8 & 255, r[14] = U >>> 16 & 255, r[15] = U >>> 24 & 255, r[16] = _ >>> 0 & 255, r[17] = _ >>> 8 & 255, r[18] = _ >>> 16 & 255, r[19] = _ >>> 24 & 255, r[20] = T >>> 0 & 255, r[21] = T >>> 8 & 255, r[22] = T >>> 16 & 255, r[23] = T >>> 24 & 255, r[24] = S >>> 0 & 255, r[25] = S >>> 8 & 255, r[26] = S >>> 16 & 255, r[27] = S >>> 24 & 255, r[28] = O >>> 0 & 255, r[29] = O >>> 8 & 255, r[30] = O >>> 16 & 255, r[31] = O >>> 24 & 255, r[32] = k >>> 0 & 255, r[33] = k >>> 8 & 255, r[34] = k >>> 16 & 255, r[35] = k >>> 24 & 255, r[36] = M >>> 0 & 255, r[37] = M >>> 8 & 255, r[38] = M >>> 16 & 255, r[39] = M >>> 24 & 255, r[40] = K >>> 0 & 255, r[41] = K >>> 8 & 255, r[42] = K >>> 16 & 255, r[43] = K >>> 24 & 255, r[44] = j >>> 0 & 255, r[45] = j >>> 8 & 255, r[46] = j >>> 16 & 255, r[47] = j >>> 24 & 255, r[48] = B >>> 0 & 255, r[49] = B >>> 8 & 255, r[50] = B >>> 16 & 255, r[51] = B >>> 24 & 255, r[52] = D >>> 0 & 255, r[53] = D >>> 8 & 255, r[54] = D >>> 16 & 255, r[55] = D >>> 24 & 255, r[56] = z >>> 0 & 255, r[57] = z >>> 8 & 255, r[58] = z >>> 16 & 255, r[59] = z >>> 24 & 255, r[60] = P >>> 0 & 255, r[61] = P >>> 8 & 255, r[62] = P >>> 16 & 255, r[63] = P >>> 24 & 255;
        }(r, e, t, n);
      }
      function w(r, e, t, n) {
        !function (r, e, t, n) {
          for (var o, i = 255 & n[0] | (255 & n[1]) << 8 | (255 & n[2]) << 16 | (255 & n[3]) << 24, a = 255 & t[0] | (255 & t[1]) << 8 | (255 & t[2]) << 16 | (255 & t[3]) << 24, f = 255 & t[4] | (255 & t[5]) << 8 | (255 & t[6]) << 16 | (255 & t[7]) << 24, c = 255 & t[8] | (255 & t[9]) << 8 | (255 & t[10]) << 16 | (255 & t[11]) << 24, s = 255 & t[12] | (255 & t[13]) << 8 | (255 & t[14]) << 16 | (255 & t[15]) << 24, u = 255 & n[4] | (255 & n[5]) << 8 | (255 & n[6]) << 16 | (255 & n[7]) << 24, h = 255 & e[0] | (255 & e[1]) << 8 | (255 & e[2]) << 16 | (255 & e[3]) << 24, l = 255 & e[4] | (255 & e[5]) << 8 | (255 & e[6]) << 16 | (255 & e[7]) << 24, y = 255 & e[8] | (255 & e[9]) << 8 | (255 & e[10]) << 16 | (255 & e[11]) << 24, p = 255 & e[12] | (255 & e[13]) << 8 | (255 & e[14]) << 16 | (255 & e[15]) << 24, d = 255 & n[8] | (255 & n[9]) << 8 | (255 & n[10]) << 16 | (255 & n[11]) << 24, b = 255 & t[16] | (255 & t[17]) << 8 | (255 & t[18]) << 16 | (255 & t[19]) << 24, v = 255 & t[20] | (255 & t[21]) << 8 | (255 & t[22]) << 16 | (255 & t[23]) << 24, g = 255 & t[24] | (255 & t[25]) << 8 | (255 & t[26]) << 16 | (255 & t[27]) << 24, w = 255 & t[28] | (255 & t[29]) << 8 | (255 & t[30]) << 16 | (255 & t[31]) << 24, A = 255 & n[12] | (255 & n[13]) << 8 | (255 & n[14]) << 16 | (255 & n[15]) << 24, m = 0; m < 20; m += 2) i ^= (o = (v ^= (o = (y ^= (o = (s ^= (o = i + v | 0) << 7 | o >>> 25) + i | 0) << 9 | o >>> 23) + s | 0) << 13 | o >>> 19) + y | 0) << 18 | o >>> 14, u ^= (o = (a ^= (o = (g ^= (o = (p ^= (o = u + a | 0) << 7 | o >>> 25) + u | 0) << 9 | o >>> 23) + p | 0) << 13 | o >>> 19) + g | 0) << 18 | o >>> 14, d ^= (o = (h ^= (o = (f ^= (o = (w ^= (o = d + h | 0) << 7 | o >>> 25) + d | 0) << 9 | o >>> 23) + w | 0) << 13 | o >>> 19) + f | 0) << 18 | o >>> 14, A ^= (o = (b ^= (o = (l ^= (o = (c ^= (o = A + b | 0) << 7 | o >>> 25) + A | 0) << 9 | o >>> 23) + c | 0) << 13 | o >>> 19) + l | 0) << 18 | o >>> 14, i ^= (o = (c ^= (o = (f ^= (o = (a ^= (o = i + c | 0) << 7 | o >>> 25) + i | 0) << 9 | o >>> 23) + a | 0) << 13 | o >>> 19) + f | 0) << 18 | o >>> 14, u ^= (o = (s ^= (o = (l ^= (o = (h ^= (o = u + s | 0) << 7 | o >>> 25) + u | 0) << 9 | o >>> 23) + h | 0) << 13 | o >>> 19) + l | 0) << 18 | o >>> 14, d ^= (o = (p ^= (o = (y ^= (o = (b ^= (o = d + p | 0) << 7 | o >>> 25) + d | 0) << 9 | o >>> 23) + b | 0) << 13 | o >>> 19) + y | 0) << 18 | o >>> 14, A ^= (o = (w ^= (o = (g ^= (o = (v ^= (o = A + w | 0) << 7 | o >>> 25) + A | 0) << 9 | o >>> 23) + v | 0) << 13 | o >>> 19) + g | 0) << 18 | o >>> 14;
          r[0] = i >>> 0 & 255, r[1] = i >>> 8 & 255, r[2] = i >>> 16 & 255, r[3] = i >>> 24 & 255, r[4] = u >>> 0 & 255, r[5] = u >>> 8 & 255, r[6] = u >>> 16 & 255, r[7] = u >>> 24 & 255, r[8] = d >>> 0 & 255, r[9] = d >>> 8 & 255, r[10] = d >>> 16 & 255, r[11] = d >>> 24 & 255, r[12] = A >>> 0 & 255, r[13] = A >>> 8 & 255, r[14] = A >>> 16 & 255, r[15] = A >>> 24 & 255, r[16] = h >>> 0 & 255, r[17] = h >>> 8 & 255, r[18] = h >>> 16 & 255, r[19] = h >>> 24 & 255, r[20] = l >>> 0 & 255, r[21] = l >>> 8 & 255, r[22] = l >>> 16 & 255, r[23] = l >>> 24 & 255, r[24] = y >>> 0 & 255, r[25] = y >>> 8 & 255, r[26] = y >>> 16 & 255, r[27] = y >>> 24 & 255, r[28] = p >>> 0 & 255, r[29] = p >>> 8 & 255, r[30] = p >>> 16 & 255, r[31] = p >>> 24 & 255;
        }(r, e, t, n);
      }
      var A = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
      function m(r, e, t, n, o, i, a) {
        var f,
          c,
          s = new Uint8Array(16),
          u = new Uint8Array(64);
        for (c = 0; c < 16; c++) s[c] = 0;
        for (c = 0; c < 8; c++) s[c] = i[c];
        for (; o >= 64;) {
          for (g(u, s, a, A), c = 0; c < 64; c++) r[e + c] = t[n + c] ^ u[c];
          for (f = 1, c = 8; c < 16; c++) f = f + (255 & s[c]) | 0, s[c] = 255 & f, f >>>= 8;
          o -= 64, e += 64, n += 64;
        }
        if (o > 0) for (g(u, s, a, A), c = 0; c < o; c++) r[e + c] = t[n + c] ^ u[c];
        return 0;
      }
      function E(r, e, t, n, o) {
        var i,
          a,
          f = new Uint8Array(16),
          c = new Uint8Array(64);
        for (a = 0; a < 16; a++) f[a] = 0;
        for (a = 0; a < 8; a++) f[a] = n[a];
        for (; t >= 64;) {
          for (g(c, f, o, A), a = 0; a < 64; a++) r[e + a] = c[a];
          for (i = 1, a = 8; a < 16; a++) i = i + (255 & f[a]) | 0, f[a] = 255 & i, i >>>= 8;
          t -= 64, e += 64;
        }
        if (t > 0) for (g(c, f, o, A), a = 0; a < t; a++) r[e + a] = c[a];
        return 0;
      }
      function x(r, e, t, n, o) {
        var i = new Uint8Array(32);
        w(i, n, o, A);
        for (var a = new Uint8Array(8), f = 0; f < 8; f++) a[f] = n[f + 16];
        return E(r, e, t, a, i);
      }
      function U(r, e, t, n, o, i, a) {
        var f = new Uint8Array(32);
        w(f, i, a, A);
        for (var c = new Uint8Array(8), s = 0; s < 8; s++) c[s] = i[s + 16];
        return m(r, e, t, n, o, c, f);
      }
      var _ = function _(r) {
        var e, t, n, o, i, a, f, c;
        this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0, e = 255 & r[0] | (255 & r[1]) << 8, this.r[0] = 8191 & e, t = 255 & r[2] | (255 & r[3]) << 8, this.r[1] = 8191 & (e >>> 13 | t << 3), n = 255 & r[4] | (255 & r[5]) << 8, this.r[2] = 7939 & (t >>> 10 | n << 6), o = 255 & r[6] | (255 & r[7]) << 8, this.r[3] = 8191 & (n >>> 7 | o << 9), i = 255 & r[8] | (255 & r[9]) << 8, this.r[4] = 255 & (o >>> 4 | i << 12), this.r[5] = i >>> 1 & 8190, a = 255 & r[10] | (255 & r[11]) << 8, this.r[6] = 8191 & (i >>> 14 | a << 2), f = 255 & r[12] | (255 & r[13]) << 8, this.r[7] = 8065 & (a >>> 11 | f << 5), c = 255 & r[14] | (255 & r[15]) << 8, this.r[8] = 8191 & (f >>> 8 | c << 8), this.r[9] = c >>> 5 & 127, this.pad[0] = 255 & r[16] | (255 & r[17]) << 8, this.pad[1] = 255 & r[18] | (255 & r[19]) << 8, this.pad[2] = 255 & r[20] | (255 & r[21]) << 8, this.pad[3] = 255 & r[22] | (255 & r[23]) << 8, this.pad[4] = 255 & r[24] | (255 & r[25]) << 8, this.pad[5] = 255 & r[26] | (255 & r[27]) << 8, this.pad[6] = 255 & r[28] | (255 & r[29]) << 8, this.pad[7] = 255 & r[30] | (255 & r[31]) << 8;
      };
      function T(r, e, t, n, o, i) {
        var a = new _(i);
        return a.update(t, n, o), a.finish(r, e), 0;
      }
      function S(r, e, t, n, o, i) {
        var a = new Uint8Array(16);
        return T(a, 0, t, n, o, i), b(r, e, a, 0);
      }
      function O(r, e, t, n, o) {
        var i;
        if (t < 32) return -1;
        for (U(r, 0, e, 0, t, n, o), T(r, 16, r, 32, t - 32, r), i = 0; i < 16; i++) r[i] = 0;
        return 0;
      }
      function k(r, e, t, n, o) {
        var i,
          a = new Uint8Array(32);
        if (t < 32) return -1;
        if (x(a, 0, 32, n, o), 0 !== S(e, 16, e, 32, t - 32, a)) return -1;
        for (U(r, 0, e, 0, t, n, o), i = 0; i < 32; i++) r[i] = 0;
        return 0;
      }
      function M(r, e) {
        var t;
        for (t = 0; t < 16; t++) r[t] = 0 | e[t];
      }
      function K(r) {
        var e,
          t,
          n = 1;
        for (e = 0; e < 16; e++) t = r[e] + n + 65535, n = Math.floor(t / 65536), r[e] = t - 65536 * n;
        r[0] += n - 1 + 37 * (n - 1);
      }
      function j(r, e, t) {
        for (var n, o = ~(t - 1), i = 0; i < 16; i++) n = o & (r[i] ^ e[i]), r[i] ^= n, e[i] ^= n;
      }
      function B(r, t) {
        var n,
          o,
          i,
          a = e(),
          f = e();
        for (n = 0; n < 16; n++) f[n] = t[n];
        for (K(f), K(f), K(f), o = 0; o < 2; o++) {
          for (a[0] = f[0] - 65517, n = 1; n < 15; n++) a[n] = f[n] - 65535 - (a[n - 1] >> 16 & 1), a[n - 1] &= 65535;
          a[15] = f[15] - 32767 - (a[14] >> 16 & 1), i = a[15] >> 16 & 1, a[14] &= 65535, j(f, a, 1 - i);
        }
        for (n = 0; n < 16; n++) r[2 * n] = 255 & f[n], r[2 * n + 1] = f[n] >> 8;
      }
      function D(r, e) {
        var t = new Uint8Array(32),
          n = new Uint8Array(32);
        return B(t, r), B(n, e), v(t, 0, n, 0);
      }
      function z(r) {
        var e = new Uint8Array(32);
        return B(e, r), 1 & e[0];
      }
      function P(r, e) {
        var t;
        for (t = 0; t < 16; t++) r[t] = e[2 * t] + (e[2 * t + 1] << 8);
        r[15] &= 32767;
      }
      function R(r, e, t) {
        for (var n = 0; n < 16; n++) r[n] = e[n] + t[n];
      }
      function L(r, e, t) {
        for (var n = 0; n < 16; n++) r[n] = e[n] - t[n];
      }
      function C(r, e, t) {
        var n,
          o,
          i = 0,
          a = 0,
          f = 0,
          c = 0,
          s = 0,
          u = 0,
          h = 0,
          l = 0,
          y = 0,
          p = 0,
          d = 0,
          b = 0,
          v = 0,
          g = 0,
          w = 0,
          A = 0,
          m = 0,
          E = 0,
          x = 0,
          U = 0,
          _ = 0,
          T = 0,
          S = 0,
          O = 0,
          k = 0,
          M = 0,
          K = 0,
          j = 0,
          B = 0,
          D = 0,
          z = 0,
          P = t[0],
          R = t[1],
          L = t[2],
          C = t[3],
          N = t[4],
          F = t[5],
          Y = t[6],
          I = t[7],
          G = t[8],
          V = t[9],
          q = t[10],
          J = t[11],
          Z = t[12],
          H = t[13],
          Q = t[14],
          X = t[15];
        i += (n = e[0]) * P, a += n * R, f += n * L, c += n * C, s += n * N, u += n * F, h += n * Y, l += n * I, y += n * G, p += n * V, d += n * q, b += n * J, v += n * Z, g += n * H, w += n * Q, A += n * X, a += (n = e[1]) * P, f += n * R, c += n * L, s += n * C, u += n * N, h += n * F, l += n * Y, y += n * I, p += n * G, d += n * V, b += n * q, v += n * J, g += n * Z, w += n * H, A += n * Q, m += n * X, f += (n = e[2]) * P, c += n * R, s += n * L, u += n * C, h += n * N, l += n * F, y += n * Y, p += n * I, d += n * G, b += n * V, v += n * q, g += n * J, w += n * Z, A += n * H, m += n * Q, E += n * X, c += (n = e[3]) * P, s += n * R, u += n * L, h += n * C, l += n * N, y += n * F, p += n * Y, d += n * I, b += n * G, v += n * V, g += n * q, w += n * J, A += n * Z, m += n * H, E += n * Q, x += n * X, s += (n = e[4]) * P, u += n * R, h += n * L, l += n * C, y += n * N, p += n * F, d += n * Y, b += n * I, v += n * G, g += n * V, w += n * q, A += n * J, m += n * Z, E += n * H, x += n * Q, U += n * X, u += (n = e[5]) * P, h += n * R, l += n * L, y += n * C, p += n * N, d += n * F, b += n * Y, v += n * I, g += n * G, w += n * V, A += n * q, m += n * J, E += n * Z, x += n * H, U += n * Q, _ += n * X, h += (n = e[6]) * P, l += n * R, y += n * L, p += n * C, d += n * N, b += n * F, v += n * Y, g += n * I, w += n * G, A += n * V, m += n * q, E += n * J, x += n * Z, U += n * H, _ += n * Q, T += n * X, l += (n = e[7]) * P, y += n * R, p += n * L, d += n * C, b += n * N, v += n * F, g += n * Y, w += n * I, A += n * G, m += n * V, E += n * q, x += n * J, U += n * Z, _ += n * H, T += n * Q, S += n * X, y += (n = e[8]) * P, p += n * R, d += n * L, b += n * C, v += n * N, g += n * F, w += n * Y, A += n * I, m += n * G, E += n * V, x += n * q, U += n * J, _ += n * Z, T += n * H, S += n * Q, O += n * X, p += (n = e[9]) * P, d += n * R, b += n * L, v += n * C, g += n * N, w += n * F, A += n * Y, m += n * I, E += n * G, x += n * V, U += n * q, _ += n * J, T += n * Z, S += n * H, O += n * Q, k += n * X, d += (n = e[10]) * P, b += n * R, v += n * L, g += n * C, w += n * N, A += n * F, m += n * Y, E += n * I, x += n * G, U += n * V, _ += n * q, T += n * J, S += n * Z, O += n * H, k += n * Q, M += n * X, b += (n = e[11]) * P, v += n * R, g += n * L, w += n * C, A += n * N, m += n * F, E += n * Y, x += n * I, U += n * G, _ += n * V, T += n * q, S += n * J, O += n * Z, k += n * H, M += n * Q, K += n * X, v += (n = e[12]) * P, g += n * R, w += n * L, A += n * C, m += n * N, E += n * F, x += n * Y, U += n * I, _ += n * G, T += n * V, S += n * q, O += n * J, k += n * Z, M += n * H, K += n * Q, j += n * X, g += (n = e[13]) * P, w += n * R, A += n * L, m += n * C, E += n * N, x += n * F, U += n * Y, _ += n * I, T += n * G, S += n * V, O += n * q, k += n * J, M += n * Z, K += n * H, j += n * Q, B += n * X, w += (n = e[14]) * P, A += n * R, m += n * L, E += n * C, x += n * N, U += n * F, _ += n * Y, T += n * I, S += n * G, O += n * V, k += n * q, M += n * J, K += n * Z, j += n * H, B += n * Q, D += n * X, A += (n = e[15]) * P, a += 38 * (E += n * L), f += 38 * (x += n * C), c += 38 * (U += n * N), s += 38 * (_ += n * F), u += 38 * (T += n * Y), h += 38 * (S += n * I), l += 38 * (O += n * G), y += 38 * (k += n * V), p += 38 * (M += n * q), d += 38 * (K += n * J), b += 38 * (j += n * Z), v += 38 * (B += n * H), g += 38 * (D += n * Q), w += 38 * (z += n * X), i = (n = (i += 38 * (m += n * R)) + (o = 1) + 65535) - 65536 * (o = Math.floor(n / 65536)), a = (n = a + o + 65535) - 65536 * (o = Math.floor(n / 65536)), f = (n = f + o + 65535) - 65536 * (o = Math.floor(n / 65536)), c = (n = c + o + 65535) - 65536 * (o = Math.floor(n / 65536)), s = (n = s + o + 65535) - 65536 * (o = Math.floor(n / 65536)), u = (n = u + o + 65535) - 65536 * (o = Math.floor(n / 65536)), h = (n = h + o + 65535) - 65536 * (o = Math.floor(n / 65536)), l = (n = l + o + 65535) - 65536 * (o = Math.floor(n / 65536)), y = (n = y + o + 65535) - 65536 * (o = Math.floor(n / 65536)), p = (n = p + o + 65535) - 65536 * (o = Math.floor(n / 65536)), d = (n = d + o + 65535) - 65536 * (o = Math.floor(n / 65536)), b = (n = b + o + 65535) - 65536 * (o = Math.floor(n / 65536)), v = (n = v + o + 65535) - 65536 * (o = Math.floor(n / 65536)), g = (n = g + o + 65535) - 65536 * (o = Math.floor(n / 65536)), w = (n = w + o + 65535) - 65536 * (o = Math.floor(n / 65536)), A = (n = A + o + 65535) - 65536 * (o = Math.floor(n / 65536)), i = (n = (i += o - 1 + 37 * (o - 1)) + (o = 1) + 65535) - 65536 * (o = Math.floor(n / 65536)), a = (n = a + o + 65535) - 65536 * (o = Math.floor(n / 65536)), f = (n = f + o + 65535) - 65536 * (o = Math.floor(n / 65536)), c = (n = c + o + 65535) - 65536 * (o = Math.floor(n / 65536)), s = (n = s + o + 65535) - 65536 * (o = Math.floor(n / 65536)), u = (n = u + o + 65535) - 65536 * (o = Math.floor(n / 65536)), h = (n = h + o + 65535) - 65536 * (o = Math.floor(n / 65536)), l = (n = l + o + 65535) - 65536 * (o = Math.floor(n / 65536)), y = (n = y + o + 65535) - 65536 * (o = Math.floor(n / 65536)), p = (n = p + o + 65535) - 65536 * (o = Math.floor(n / 65536)), d = (n = d + o + 65535) - 65536 * (o = Math.floor(n / 65536)), b = (n = b + o + 65535) - 65536 * (o = Math.floor(n / 65536)), v = (n = v + o + 65535) - 65536 * (o = Math.floor(n / 65536)), g = (n = g + o + 65535) - 65536 * (o = Math.floor(n / 65536)), w = (n = w + o + 65535) - 65536 * (o = Math.floor(n / 65536)), A = (n = A + o + 65535) - 65536 * (o = Math.floor(n / 65536)), i += o - 1 + 37 * (o - 1), r[0] = i, r[1] = a, r[2] = f, r[3] = c, r[4] = s, r[5] = u, r[6] = h, r[7] = l, r[8] = y, r[9] = p, r[10] = d, r[11] = b, r[12] = v, r[13] = g, r[14] = w, r[15] = A;
      }
      function N(r, e) {
        C(r, e, e);
      }
      function F(r, t) {
        var n,
          o = e();
        for (n = 0; n < 16; n++) o[n] = t[n];
        for (n = 253; n >= 0; n--) N(o, o), 2 !== n && 4 !== n && C(o, o, t);
        for (n = 0; n < 16; n++) r[n] = o[n];
      }
      function Y(r, t) {
        var n,
          o = e();
        for (n = 0; n < 16; n++) o[n] = t[n];
        for (n = 250; n >= 0; n--) N(o, o), 1 !== n && C(o, o, t);
        for (n = 0; n < 16; n++) r[n] = o[n];
      }
      function I(r, t, n) {
        var o,
          i,
          a = new Uint8Array(32),
          f = new Float64Array(80),
          s = e(),
          u = e(),
          h = e(),
          l = e(),
          y = e(),
          p = e();
        for (i = 0; i < 31; i++) a[i] = t[i];
        for (a[31] = 127 & t[31] | 64, a[0] &= 248, P(f, n), i = 0; i < 16; i++) u[i] = f[i], l[i] = s[i] = h[i] = 0;
        for (s[0] = l[0] = 1, i = 254; i >= 0; --i) j(s, u, o = a[i >>> 3] >>> (7 & i) & 1), j(h, l, o), R(y, s, h), L(s, s, h), R(h, u, l), L(u, u, l), N(l, y), N(p, s), C(s, h, s), C(h, u, y), R(y, s, h), L(s, s, h), N(u, s), L(h, l, p), C(s, h, c), R(s, s, l), C(h, h, s), C(s, l, p), C(l, u, f), N(u, y), j(s, u, o), j(h, l, o);
        for (i = 0; i < 16; i++) f[i + 16] = s[i], f[i + 32] = h[i], f[i + 48] = u[i], f[i + 64] = l[i];
        var d = f.subarray(32),
          b = f.subarray(16);
        return F(d, d), C(b, b, d), B(r, b), 0;
      }
      function G(r, e) {
        return I(r, e, i);
      }
      function V(r, e) {
        return t(e, 32), G(r, e);
      }
      function q(r, e, t) {
        var o = new Uint8Array(32);
        return I(o, t, e), w(r, n, o, A);
      }
      _.prototype.blocks = function (r, e, t) {
        for (var n, o, i, a, f, c, s, u, h, l, y, p, d, b, v, g, w, A, m, E = this.fin ? 0 : 2048, x = this.h[0], U = this.h[1], _ = this.h[2], T = this.h[3], S = this.h[4], O = this.h[5], k = this.h[6], M = this.h[7], K = this.h[8], j = this.h[9], B = this.r[0], D = this.r[1], z = this.r[2], P = this.r[3], R = this.r[4], L = this.r[5], C = this.r[6], N = this.r[7], F = this.r[8], Y = this.r[9]; t >= 16;) l = h = 0, l += (x += 8191 & (n = 255 & r[e + 0] | (255 & r[e + 1]) << 8)) * B, l += (U += 8191 & (n >>> 13 | (o = 255 & r[e + 2] | (255 & r[e + 3]) << 8) << 3)) * (5 * Y), l += (_ += 8191 & (o >>> 10 | (i = 255 & r[e + 4] | (255 & r[e + 5]) << 8) << 6)) * (5 * F), l += (T += 8191 & (i >>> 7 | (a = 255 & r[e + 6] | (255 & r[e + 7]) << 8) << 9)) * (5 * N), h = (l += (S += 8191 & (a >>> 4 | (f = 255 & r[e + 8] | (255 & r[e + 9]) << 8) << 12)) * (5 * C)) >>> 13, l &= 8191, l += (O += f >>> 1 & 8191) * (5 * L), l += (k += 8191 & (f >>> 14 | (c = 255 & r[e + 10] | (255 & r[e + 11]) << 8) << 2)) * (5 * R), l += (M += 8191 & (c >>> 11 | (s = 255 & r[e + 12] | (255 & r[e + 13]) << 8) << 5)) * (5 * P), l += (K += 8191 & (s >>> 8 | (u = 255 & r[e + 14] | (255 & r[e + 15]) << 8) << 8)) * (5 * z), y = h += (l += (j += u >>> 5 | E) * (5 * D)) >>> 13, y += x * D, y += U * B, y += _ * (5 * Y), y += T * (5 * F), h = (y += S * (5 * N)) >>> 13, y &= 8191, y += O * (5 * C), y += k * (5 * L), y += M * (5 * R), y += K * (5 * P), h += (y += j * (5 * z)) >>> 13, y &= 8191, p = h, p += x * z, p += U * D, p += _ * B, p += T * (5 * Y), h = (p += S * (5 * F)) >>> 13, p &= 8191, p += O * (5 * N), p += k * (5 * C), p += M * (5 * L), p += K * (5 * R), d = h += (p += j * (5 * P)) >>> 13, d += x * P, d += U * z, d += _ * D, d += T * B, h = (d += S * (5 * Y)) >>> 13, d &= 8191, d += O * (5 * F), d += k * (5 * N), d += M * (5 * C), d += K * (5 * L), b = h += (d += j * (5 * R)) >>> 13, b += x * R, b += U * P, b += _ * z, b += T * D, h = (b += S * B) >>> 13, b &= 8191, b += O * (5 * Y), b += k * (5 * F), b += M * (5 * N), b += K * (5 * C), v = h += (b += j * (5 * L)) >>> 13, v += x * L, v += U * R, v += _ * P, v += T * z, h = (v += S * D) >>> 13, v &= 8191, v += O * B, v += k * (5 * Y), v += M * (5 * F), v += K * (5 * N), g = h += (v += j * (5 * C)) >>> 13, g += x * C, g += U * L, g += _ * R, g += T * P, h = (g += S * z) >>> 13, g &= 8191, g += O * D, g += k * B, g += M * (5 * Y), g += K * (5 * F), w = h += (g += j * (5 * N)) >>> 13, w += x * N, w += U * C, w += _ * L, w += T * R, h = (w += S * P) >>> 13, w &= 8191, w += O * z, w += k * D, w += M * B, w += K * (5 * Y), A = h += (w += j * (5 * F)) >>> 13, A += x * F, A += U * N, A += _ * C, A += T * L, h = (A += S * R) >>> 13, A &= 8191, A += O * P, A += k * z, A += M * D, A += K * B, m = h += (A += j * (5 * Y)) >>> 13, m += x * Y, m += U * F, m += _ * N, m += T * C, h = (m += S * L) >>> 13, m &= 8191, m += O * R, m += k * P, m += M * z, m += K * D, x = l = 8191 & (h = (h = ((h += (m += j * B) >>> 13) << 2) + h | 0) + (l &= 8191) | 0), U = y += h >>>= 13, _ = p &= 8191, T = d &= 8191, S = b &= 8191, O = v &= 8191, k = g &= 8191, M = w &= 8191, K = A &= 8191, j = m &= 8191, e += 16, t -= 16;
        this.h[0] = x, this.h[1] = U, this.h[2] = _, this.h[3] = T, this.h[4] = S, this.h[5] = O, this.h[6] = k, this.h[7] = M, this.h[8] = K, this.h[9] = j;
      }, _.prototype.finish = function (r, e) {
        var t,
          n,
          o,
          i,
          a = new Uint16Array(10);
        if (this.leftover) {
          for (i = this.leftover, this.buffer[i++] = 1; i < 16; i++) this.buffer[i] = 0;
          this.fin = 1, this.blocks(this.buffer, 0, 16);
        }
        for (t = this.h[1] >>> 13, this.h[1] &= 8191, i = 2; i < 10; i++) this.h[i] += t, t = this.h[i] >>> 13, this.h[i] &= 8191;
        for (this.h[0] += 5 * t, t = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += t, t = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += t, a[0] = this.h[0] + 5, t = a[0] >>> 13, a[0] &= 8191, i = 1; i < 10; i++) a[i] = this.h[i] + t, t = a[i] >>> 13, a[i] &= 8191;
        for (a[9] -= 8192, n = (1 ^ t) - 1, i = 0; i < 10; i++) a[i] &= n;
        for (n = ~n, i = 0; i < 10; i++) this.h[i] = this.h[i] & n | a[i];
        for (this.h[0] = 65535 & (this.h[0] | this.h[1] << 13), this.h[1] = 65535 & (this.h[1] >>> 3 | this.h[2] << 10), this.h[2] = 65535 & (this.h[2] >>> 6 | this.h[3] << 7), this.h[3] = 65535 & (this.h[3] >>> 9 | this.h[4] << 4), this.h[4] = 65535 & (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14), this.h[5] = 65535 & (this.h[6] >>> 2 | this.h[7] << 11), this.h[6] = 65535 & (this.h[7] >>> 5 | this.h[8] << 8), this.h[7] = 65535 & (this.h[8] >>> 8 | this.h[9] << 5), o = this.h[0] + this.pad[0], this.h[0] = 65535 & o, i = 1; i < 8; i++) o = (this.h[i] + this.pad[i] | 0) + (o >>> 16) | 0, this.h[i] = 65535 & o;
        r[e + 0] = this.h[0] >>> 0 & 255, r[e + 1] = this.h[0] >>> 8 & 255, r[e + 2] = this.h[1] >>> 0 & 255, r[e + 3] = this.h[1] >>> 8 & 255, r[e + 4] = this.h[2] >>> 0 & 255, r[e + 5] = this.h[2] >>> 8 & 255, r[e + 6] = this.h[3] >>> 0 & 255, r[e + 7] = this.h[3] >>> 8 & 255, r[e + 8] = this.h[4] >>> 0 & 255, r[e + 9] = this.h[4] >>> 8 & 255, r[e + 10] = this.h[5] >>> 0 & 255, r[e + 11] = this.h[5] >>> 8 & 255, r[e + 12] = this.h[6] >>> 0 & 255, r[e + 13] = this.h[6] >>> 8 & 255, r[e + 14] = this.h[7] >>> 0 & 255, r[e + 15] = this.h[7] >>> 8 & 255;
      }, _.prototype.update = function (r, e, t) {
        var n, o;
        if (this.leftover) {
          for ((o = 16 - this.leftover) > t && (o = t), n = 0; n < o; n++) this.buffer[this.leftover + n] = r[e + n];
          if (t -= o, e += o, this.leftover += o, this.leftover < 16) return;
          this.blocks(this.buffer, 0, 16), this.leftover = 0;
        }
        if (t >= 16 && (o = t - t % 16, this.blocks(r, e, o), e += o, t -= o), t) {
          for (n = 0; n < t; n++) this.buffer[this.leftover + n] = r[e + n];
          this.leftover += t;
        }
      };
      var J = O,
        Z = k;
      var H = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];
      function Q(r, e, t, n) {
        for (var o, i, a, f, c, s, u, h, l, y, p, d, b, v, g, w, A, m, E, x, U, _, T, S, O, k, M = new Int32Array(16), K = new Int32Array(16), j = r[0], B = r[1], D = r[2], z = r[3], P = r[4], R = r[5], L = r[6], C = r[7], N = e[0], F = e[1], Y = e[2], I = e[3], G = e[4], V = e[5], q = e[6], J = e[7], Z = 0; n >= 128;) {
          for (E = 0; E < 16; E++) x = 8 * E + Z, M[E] = t[x + 0] << 24 | t[x + 1] << 16 | t[x + 2] << 8 | t[x + 3], K[E] = t[x + 4] << 24 | t[x + 5] << 16 | t[x + 6] << 8 | t[x + 7];
          for (E = 0; E < 80; E++) if (o = j, i = B, a = D, f = z, c = P, s = R, u = L, C, l = N, y = F, p = Y, d = I, b = G, v = V, g = q, J, T = 65535 & (_ = J), S = _ >>> 16, O = 65535 & (U = C), k = U >>> 16, T += 65535 & (_ = (G >>> 14 | P << 18) ^ (G >>> 18 | P << 14) ^ (P >>> 9 | G << 23)), S += _ >>> 16, O += 65535 & (U = (P >>> 14 | G << 18) ^ (P >>> 18 | G << 14) ^ (G >>> 9 | P << 23)), k += U >>> 16, T += 65535 & (_ = G & V ^ ~G & q), S += _ >>> 16, O += 65535 & (U = P & R ^ ~P & L), k += U >>> 16, T += 65535 & (_ = H[2 * E + 1]), S += _ >>> 16, O += 65535 & (U = H[2 * E]), k += U >>> 16, U = M[E % 16], S += (_ = K[E % 16]) >>> 16, O += 65535 & U, k += U >>> 16, O += (S += (T += 65535 & _) >>> 16) >>> 16, T = 65535 & (_ = m = 65535 & T | S << 16), S = _ >>> 16, O = 65535 & (U = A = 65535 & O | (k += O >>> 16) << 16), k = U >>> 16, T += 65535 & (_ = (N >>> 28 | j << 4) ^ (j >>> 2 | N << 30) ^ (j >>> 7 | N << 25)), S += _ >>> 16, O += 65535 & (U = (j >>> 28 | N << 4) ^ (N >>> 2 | j << 30) ^ (N >>> 7 | j << 25)), k += U >>> 16, S += (_ = N & F ^ N & Y ^ F & Y) >>> 16, O += 65535 & (U = j & B ^ j & D ^ B & D), k += U >>> 16, h = 65535 & (O += (S += (T += 65535 & _) >>> 16) >>> 16) | (k += O >>> 16) << 16, w = 65535 & T | S << 16, T = 65535 & (_ = d), S = _ >>> 16, O = 65535 & (U = f), k = U >>> 16, S += (_ = m) >>> 16, O += 65535 & (U = A), k += U >>> 16, B = o, D = i, z = a, P = f = 65535 & (O += (S += (T += 65535 & _) >>> 16) >>> 16) | (k += O >>> 16) << 16, R = c, L = s, C = u, j = h, F = l, Y = y, I = p, G = d = 65535 & T | S << 16, V = b, q = v, J = g, N = w, E % 16 == 15) for (x = 0; x < 16; x++) U = M[x], T = 65535 & (_ = K[x]), S = _ >>> 16, O = 65535 & U, k = U >>> 16, U = M[(x + 9) % 16], T += 65535 & (_ = K[(x + 9) % 16]), S += _ >>> 16, O += 65535 & U, k += U >>> 16, A = M[(x + 1) % 16], T += 65535 & (_ = ((m = K[(x + 1) % 16]) >>> 1 | A << 31) ^ (m >>> 8 | A << 24) ^ (m >>> 7 | A << 25)), S += _ >>> 16, O += 65535 & (U = (A >>> 1 | m << 31) ^ (A >>> 8 | m << 24) ^ A >>> 7), k += U >>> 16, A = M[(x + 14) % 16], S += (_ = ((m = K[(x + 14) % 16]) >>> 19 | A << 13) ^ (A >>> 29 | m << 3) ^ (m >>> 6 | A << 26)) >>> 16, O += 65535 & (U = (A >>> 19 | m << 13) ^ (m >>> 29 | A << 3) ^ A >>> 6), k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, M[x] = 65535 & O | k << 16, K[x] = 65535 & T | S << 16;
          T = 65535 & (_ = N), S = _ >>> 16, O = 65535 & (U = j), k = U >>> 16, U = r[0], S += (_ = e[0]) >>> 16, O += 65535 & U, k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, r[0] = j = 65535 & O | k << 16, e[0] = N = 65535 & T | S << 16, T = 65535 & (_ = F), S = _ >>> 16, O = 65535 & (U = B), k = U >>> 16, U = r[1], S += (_ = e[1]) >>> 16, O += 65535 & U, k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, r[1] = B = 65535 & O | k << 16, e[1] = F = 65535 & T | S << 16, T = 65535 & (_ = Y), S = _ >>> 16, O = 65535 & (U = D), k = U >>> 16, U = r[2], S += (_ = e[2]) >>> 16, O += 65535 & U, k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, r[2] = D = 65535 & O | k << 16, e[2] = Y = 65535 & T | S << 16, T = 65535 & (_ = I), S = _ >>> 16, O = 65535 & (U = z), k = U >>> 16, U = r[3], S += (_ = e[3]) >>> 16, O += 65535 & U, k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, r[3] = z = 65535 & O | k << 16, e[3] = I = 65535 & T | S << 16, T = 65535 & (_ = G), S = _ >>> 16, O = 65535 & (U = P), k = U >>> 16, U = r[4], S += (_ = e[4]) >>> 16, O += 65535 & U, k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, r[4] = P = 65535 & O | k << 16, e[4] = G = 65535 & T | S << 16, T = 65535 & (_ = V), S = _ >>> 16, O = 65535 & (U = R), k = U >>> 16, U = r[5], S += (_ = e[5]) >>> 16, O += 65535 & U, k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, r[5] = R = 65535 & O | k << 16, e[5] = V = 65535 & T | S << 16, T = 65535 & (_ = q), S = _ >>> 16, O = 65535 & (U = L), k = U >>> 16, U = r[6], S += (_ = e[6]) >>> 16, O += 65535 & U, k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, r[6] = L = 65535 & O | k << 16, e[6] = q = 65535 & T | S << 16, T = 65535 & (_ = J), S = _ >>> 16, O = 65535 & (U = C), k = U >>> 16, U = r[7], S += (_ = e[7]) >>> 16, O += 65535 & U, k += U >>> 16, k += (O += (S += (T += 65535 & _) >>> 16) >>> 16) >>> 16, r[7] = C = 65535 & O | k << 16, e[7] = J = 65535 & T | S << 16, Z += 128, n -= 128;
        }
        return n;
      }
      function X(r, e, t) {
        var n,
          o = new Int32Array(8),
          i = new Int32Array(8),
          a = new Uint8Array(256),
          f = t;
        for (o[0] = 1779033703, o[1] = 3144134277, o[2] = 1013904242, o[3] = 2773480762, o[4] = 1359893119, o[5] = 2600822924, o[6] = 528734635, o[7] = 1541459225, i[0] = 4089235720, i[1] = 2227873595, i[2] = 4271175723, i[3] = 1595750129, i[4] = 2917565137, i[5] = 725511199, i[6] = 4215389547, i[7] = 327033209, Q(o, i, e, t), t %= 128, n = 0; n < t; n++) a[n] = e[f - t + n];
        for (a[t] = 128, a[(t = 256 - 128 * (t < 112 ? 1 : 0)) - 9] = 0, p(a, t - 8, f / 536870912 | 0, f << 3), Q(o, i, a, t), n = 0; n < 8; n++) p(r, 8 * n, o[n], i[n]);
        return 0;
      }
      function $(r, t) {
        var n = e(),
          o = e(),
          i = e(),
          a = e(),
          f = e(),
          c = e(),
          s = e(),
          h = e(),
          l = e();
        L(n, r[1], r[0]), L(l, t[1], t[0]), C(n, n, l), R(o, r[0], r[1]), R(l, t[0], t[1]), C(o, o, l), C(i, r[3], t[3]), C(i, i, u), C(a, r[2], t[2]), R(a, a, a), L(f, o, n), L(c, a, i), R(s, a, i), R(h, o, n), C(r[0], f, c), C(r[1], h, s), C(r[2], s, c), C(r[3], f, h);
      }
      function W(r, e, t) {
        var n;
        for (n = 0; n < 4; n++) j(r[n], e[n], t);
      }
      function rr(r, t) {
        var n = e(),
          o = e(),
          i = e();
        F(i, t[2]), C(n, t[0], i), C(o, t[1], i), B(r, o), r[31] ^= z(n) << 7;
      }
      function er(r, e, t) {
        var n, o;
        for (M(r[0], a), M(r[1], f), M(r[2], f), M(r[3], a), o = 255; o >= 0; --o) W(r, e, n = t[o / 8 | 0] >> (7 & o) & 1), $(e, r), $(r, r), W(r, e, n);
      }
      function tr(r, t) {
        var n = [e(), e(), e(), e()];
        M(n[0], h), M(n[1], l), M(n[2], f), C(n[3], h, l), er(r, n, t);
      }
      function nr(r, n, o) {
        var i,
          a = new Uint8Array(64),
          f = [e(), e(), e(), e()];
        for (o || t(n, 32), X(a, n, 32), a[0] &= 248, a[31] &= 127, a[31] |= 64, tr(f, a), rr(r, f), i = 0; i < 32; i++) n[i + 32] = r[i];
        return 0;
      }
      var or = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
      function ir(r, e) {
        var t, n, o, i;
        for (n = 63; n >= 32; --n) {
          for (t = 0, o = n - 32, i = n - 12; o < i; ++o) e[o] += t - 16 * e[n] * or[o - (n - 32)], t = Math.floor((e[o] + 128) / 256), e[o] -= 256 * t;
          e[o] += t, e[n] = 0;
        }
        for (t = 0, o = 0; o < 32; o++) e[o] += t - (e[31] >> 4) * or[o], t = e[o] >> 8, e[o] &= 255;
        for (o = 0; o < 32; o++) e[o] -= t * or[o];
        for (n = 0; n < 32; n++) e[n + 1] += e[n] >> 8, r[n] = 255 & e[n];
      }
      function ar(r) {
        var e,
          t = new Float64Array(64);
        for (e = 0; e < 64; e++) t[e] = r[e];
        for (e = 0; e < 64; e++) r[e] = 0;
        ir(r, t);
      }
      function fr(r, t, n, o) {
        var i,
          a,
          f = new Uint8Array(64),
          c = new Uint8Array(64),
          s = new Uint8Array(64),
          u = new Float64Array(64),
          h = [e(), e(), e(), e()];
        X(f, o, 32), f[0] &= 248, f[31] &= 127, f[31] |= 64;
        var l = n + 64;
        for (i = 0; i < n; i++) r[64 + i] = t[i];
        for (i = 0; i < 32; i++) r[32 + i] = f[32 + i];
        for (X(s, r.subarray(32), n + 32), ar(s), tr(h, s), rr(r, h), i = 32; i < 64; i++) r[i] = o[i];
        for (X(c, r, n + 64), ar(c), i = 0; i < 64; i++) u[i] = 0;
        for (i = 0; i < 32; i++) u[i] = s[i];
        for (i = 0; i < 32; i++) for (a = 0; a < 32; a++) u[i + a] += c[i] * f[a];
        return ir(r.subarray(32), u), l;
      }
      function cr(r, t, n, o) {
        var i,
          c = new Uint8Array(32),
          u = new Uint8Array(64),
          h = [e(), e(), e(), e()],
          l = [e(), e(), e(), e()];
        if (n < 64) return -1;
        if (function (r, t) {
          var n = e(),
            o = e(),
            i = e(),
            c = e(),
            u = e(),
            h = e(),
            l = e();
          return M(r[2], f), P(r[1], t), N(i, r[1]), C(c, i, s), L(i, i, r[2]), R(c, r[2], c), N(u, c), N(h, u), C(l, h, u), C(n, l, i), C(n, n, c), Y(n, n), C(n, n, i), C(n, n, c), C(n, n, c), C(r[0], n, c), N(o, r[0]), C(o, o, c), D(o, i) && C(r[0], r[0], y), N(o, r[0]), C(o, o, c), D(o, i) ? -1 : (z(r[0]) === t[31] >> 7 && L(r[0], a, r[0]), C(r[3], r[0], r[1]), 0);
        }(l, o)) return -1;
        for (i = 0; i < n; i++) r[i] = t[i];
        for (i = 0; i < 32; i++) r[i + 32] = o[i];
        if (X(u, r, n), ar(u), er(h, l, u), tr(l, t.subarray(32)), $(h, l), rr(c, h), n -= 64, v(t, 0, c, 0)) {
          for (i = 0; i < n; i++) r[i] = 0;
          return -1;
        }
        for (i = 0; i < n; i++) r[i] = t[i + 64];
        return n;
      }
      var sr = 16,
        ur = 64,
        hr = 32,
        lr = 64;
      function yr(r, e) {
        if (32 !== r.length) throw new Error("bad key size");
        if (24 !== e.length) throw new Error("bad nonce size");
      }
      function pr() {
        for (var r = 0; r < arguments.length; r++) if (!(arguments[r] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
      }
      function dr(r) {
        for (var e = 0; e < r.length; e++) r[e] = 0;
      }
      r.lowlevel = {
        crypto_core_hsalsa20: w,
        crypto_stream_xor: U,
        crypto_stream: x,
        crypto_stream_salsa20_xor: m,
        crypto_stream_salsa20: E,
        crypto_onetimeauth: T,
        crypto_onetimeauth_verify: S,
        crypto_verify_16: b,
        crypto_verify_32: v,
        crypto_secretbox: O,
        crypto_secretbox_open: k,
        crypto_scalarmult: I,
        crypto_scalarmult_base: G,
        crypto_box_beforenm: q,
        crypto_box_afternm: J,
        crypto_box: function crypto_box(r, e, t, n, o, i) {
          var a = new Uint8Array(32);
          return q(a, o, i), J(r, e, t, n, a);
        },
        crypto_box_open: function crypto_box_open(r, e, t, n, o, i) {
          var a = new Uint8Array(32);
          return q(a, o, i), Z(r, e, t, n, a);
        },
        crypto_box_keypair: V,
        crypto_hash: X,
        crypto_sign: fr,
        crypto_sign_keypair: nr,
        crypto_sign_open: cr,
        crypto_secretbox_KEYBYTES: 32,
        crypto_secretbox_NONCEBYTES: 24,
        crypto_secretbox_ZEROBYTES: 32,
        crypto_secretbox_BOXZEROBYTES: sr,
        crypto_scalarmult_BYTES: 32,
        crypto_scalarmult_SCALARBYTES: 32,
        crypto_box_PUBLICKEYBYTES: 32,
        crypto_box_SECRETKEYBYTES: 32,
        crypto_box_BEFORENMBYTES: 32,
        crypto_box_NONCEBYTES: 24,
        crypto_box_ZEROBYTES: 32,
        crypto_box_BOXZEROBYTES: 16,
        crypto_sign_BYTES: ur,
        crypto_sign_PUBLICKEYBYTES: hr,
        crypto_sign_SECRETKEYBYTES: lr,
        crypto_sign_SEEDBYTES: 32,
        crypto_hash_BYTES: 64,
        gf: e,
        D: s,
        L: or,
        pack25519: B,
        unpack25519: P,
        M: C,
        A: R,
        S: N,
        Z: L,
        pow2523: Y,
        add: $,
        set25519: M,
        modL: ir,
        scalarmult: er,
        scalarbase: tr
      }, r.randomBytes = function (r) {
        var e = new Uint8Array(r);
        return t(e, r), e;
      }, r.secretbox = function (r, e, t) {
        pr(r, e, t), yr(t, e);
        for (var n = new Uint8Array(32 + r.length), o = new Uint8Array(n.length), i = 0; i < r.length; i++) n[i + 32] = r[i];
        return O(o, n, n.length, e, t), o.subarray(sr);
      }, r.secretbox.open = function (r, e, t) {
        pr(r, e, t), yr(t, e);
        for (var n = new Uint8Array(sr + r.length), o = new Uint8Array(n.length), i = 0; i < r.length; i++) n[i + sr] = r[i];
        return n.length < 32 || 0 !== k(o, n, n.length, e, t) ? null : o.subarray(32);
      }, r.secretbox.keyLength = 32, r.secretbox.nonceLength = 24, r.secretbox.overheadLength = sr, r.scalarMult = function (r, e) {
        if (pr(r, e), 32 !== r.length) throw new Error("bad n size");
        if (32 !== e.length) throw new Error("bad p size");
        var t = new Uint8Array(32);
        return I(t, r, e), t;
      }, r.scalarMult.base = function (r) {
        if (pr(r), 32 !== r.length) throw new Error("bad n size");
        var e = new Uint8Array(32);
        return G(e, r), e;
      }, r.scalarMult.scalarLength = 32, r.scalarMult.groupElementLength = 32, r.box = function (e, t, n, o) {
        var i = r.box.before(n, o);
        return r.secretbox(e, t, i);
      }, r.box.before = function (r, e) {
        pr(r, e), function (r, e) {
          if (32 !== r.length) throw new Error("bad public key size");
          if (32 !== e.length) throw new Error("bad secret key size");
        }(r, e);
        var t = new Uint8Array(32);
        return q(t, r, e), t;
      }, r.box.after = r.secretbox, r.box.open = function (e, t, n, o) {
        var i = r.box.before(n, o);
        return r.secretbox.open(e, t, i);
      }, r.box.open.after = r.secretbox.open, r.box.keyPair = function () {
        var r = new Uint8Array(32),
          e = new Uint8Array(32);
        return V(r, e), {
          publicKey: r,
          secretKey: e
        };
      }, r.box.keyPair.fromSecretKey = function (r) {
        if (pr(r), 32 !== r.length) throw new Error("bad secret key size");
        var e = new Uint8Array(32);
        return G(e, r), {
          publicKey: e,
          secretKey: new Uint8Array(r)
        };
      }, r.box.publicKeyLength = 32, r.box.secretKeyLength = 32, r.box.sharedKeyLength = 32, r.box.nonceLength = 24, r.box.overheadLength = r.secretbox.overheadLength, r.sign = function (r, e) {
        if (pr(r, e), e.length !== lr) throw new Error("bad secret key size");
        var t = new Uint8Array(ur + r.length);
        return fr(t, r, r.length, e), t;
      }, r.sign.open = function (r, e) {
        if (pr(r, e), e.length !== hr) throw new Error("bad public key size");
        var t = new Uint8Array(r.length),
          n = cr(t, r, r.length, e);
        if (n < 0) return null;
        for (var o = new Uint8Array(n), i = 0; i < o.length; i++) o[i] = t[i];
        return o;
      }, r.sign.detached = function (e, t) {
        for (var n = r.sign(e, t), o = new Uint8Array(ur), i = 0; i < o.length; i++) o[i] = n[i];
        return o;
      }, r.sign.detached.verify = function (r, e, t) {
        if (pr(r, e, t), e.length !== ur) throw new Error("bad signature size");
        if (t.length !== hr) throw new Error("bad public key size");
        var n,
          o = new Uint8Array(ur + r.length),
          i = new Uint8Array(ur + r.length);
        for (n = 0; n < ur; n++) o[n] = e[n];
        for (n = 0; n < r.length; n++) o[n + ur] = r[n];
        return cr(i, o, o.length, t) >= 0;
      }, r.sign.keyPair = function () {
        var r = new Uint8Array(hr),
          e = new Uint8Array(lr);
        return nr(r, e), {
          publicKey: r,
          secretKey: e
        };
      }, r.sign.keyPair.fromSecretKey = function (r) {
        if (pr(r), r.length !== lr) throw new Error("bad secret key size");
        for (var e = new Uint8Array(hr), t = 0; t < e.length; t++) e[t] = r[32 + t];
        return {
          publicKey: e,
          secretKey: new Uint8Array(r)
        };
      }, r.sign.keyPair.fromSeed = function (r) {
        if (pr(r), 32 !== r.length) throw new Error("bad seed size");
        for (var e = new Uint8Array(hr), t = new Uint8Array(lr), n = 0; n < 32; n++) t[n] = r[n];
        return nr(e, t, !0), {
          publicKey: e,
          secretKey: t
        };
      }, r.sign.publicKeyLength = hr, r.sign.secretKeyLength = lr, r.sign.seedLength = 32, r.sign.signatureLength = ur, r.hash = function (r) {
        pr(r);
        var e = new Uint8Array(64);
        return X(e, r, r.length), e;
      }, r.hash.hashLength = 64, r.verify = function (r, e) {
        return pr(r, e), 0 !== r.length && 0 !== e.length && r.length === e.length && 0 === d(r, 0, e, 0, r.length);
      }, r.setPRNG = function (r) {
        t = r;
      }, function () {
        var e = "undefined" != typeof self ? self.crypto || self.msCrypto : null;
        if (e && e.getRandomValues) {
          r.setPRNG(function (r, t) {
            var n,
              o = new Uint8Array(t);
            for (n = 0; n < t; n += 65536) e.getRandomValues(o.subarray(n, n + Math.min(t - n, 65536)));
            for (n = 0; n < t; n++) r[n] = o[n];
            dr(o);
          });
        } else (e = o) && e.randomBytes && r.setPRNG(function (r, t) {
          var n,
            o = e.randomBytes(t);
          for (n = 0; n < t; n++) r[n] = o[n];
          dr(o);
        });
      }();
    }(r.exports ? r.exports : self.nacl = self.nacl || {});
  });
var a = {
    RSA: 0,
    Ed25519: 1,
    Secp256k1: 2
  },
  f = {
    0: "RSA",
    1: "Ed25519",
    2: "Secp256k1"
  };
function c(r) {
  var e = p();
  return function (r, e) {
    var t = r.Type;
    void 0 !== t && (T(e, 8), T(e, a[t]));
    var n = r.Data;
    void 0 !== n && (T(e, 18), T(e, n.length), E(e, n));
  }(r, e), b(e);
}
function s(r) {
  return function (r) {
    var e = {};
    r: for (; !g(r);) {
      var _t = _(r);
      switch (_t >>> 3) {
        case 0:
          break r;
        case 1:
          e.Type = f[_(r)];
          break;
        case 2:
          e.Data = m(r, _(r));
          break;
        default:
          l(r, 7 & _t);
      }
    }
    if (void 0 === e.Type) throw new Error("Missing required field: Type");
    if (void 0 === e.Data) throw new Error("Missing required field: Data");
    return e;
  }(d(r));
}
function u(r) {
  var e = p();
  return function (r, e) {
    var t = r.Type;
    void 0 !== t && (T(e, 8), T(e, a[t]));
    var n = r.Data;
    void 0 !== n && (T(e, 18), T(e, n.length), E(e, n));
  }(r, e), b(e);
}
function h(r) {
  return function (r) {
    var e = {};
    r: for (; !g(r);) {
      var _t2 = _(r);
      switch (_t2 >>> 3) {
        case 0:
          break r;
        case 1:
          e.Type = f[_(r)];
          break;
        case 2:
          e.Data = m(r, _(r));
          break;
        default:
          l(r, 7 & _t2);
      }
    }
    if (void 0 === e.Type) throw new Error("Missing required field: Type");
    if (void 0 === e.Data) throw new Error("Missing required field: Data");
    return e;
  }(d(r));
}
function l(r, e) {
  switch (e) {
    case 0:
      for (; 128 & x(r););
      break;
    case 2:
      v(r, _(r));
      break;
    case 5:
      v(r, 4);
      break;
    case 1:
      v(r, 8);
      break;
    default:
      throw new Error("Unimplemented type: " + e);
  }
}
var y = [];
function p() {
  var r = y.pop();
  return r ? (r.offset = r.limit = 0, r) : {
    bytes: new Uint8Array(64),
    offset: 0,
    limit: 0
  };
}
function d(r) {
  return {
    bytes: r,
    offset: 0,
    limit: r.length
  };
}
function b(r) {
  var e = r.bytes,
    t = r.limit;
  return e.length === t ? e : e.subarray(0, t);
}
function v(r, e) {
  if (r.offset + e > r.limit) throw new Error("Skip past limit");
  r.offset += e;
}
function g(r) {
  return r.offset >= r.limit;
}
function w(r, e) {
  var t = r.bytes,
    n = r.offset,
    o = r.limit,
    i = n + e;
  if (i > t.length) {
    var _e = new Uint8Array(2 * i);
    _e.set(t), r.bytes = _e;
  }
  return r.offset = i, i > o && (r.limit = i), n;
}
function A(r, e) {
  var t = r.offset;
  if (t + e > r.limit) throw new Error("Read past limit");
  return r.offset += e, t;
}
function m(r, e) {
  var t = A(r, e);
  return r.bytes.subarray(t, t + e);
}
function E(r, e) {
  var t = w(r, e.length);
  r.bytes.set(e, t);
}
function x(r) {
  return r.bytes[A(r, 1)];
}
function U(r, e) {
  var t = w(r, 1);
  r.bytes[t] = e;
}
function _(r) {
  var e,
    t = 0,
    n = 0;
  do {
    e = x(r), t < 32 && (n |= (127 & e) << t), t += 7;
  } while (128 & e);
  return n;
}
function T(r, e) {
  for (e >>>= 0; e >= 128;) U(r, 127 & e | 128), e >>>= 7;
  U(r, e);
}
var S = t(function (e) {
  var t, n;
  t = r, n = function n(r) {
    if (!r) throw new Error("tweetnacl not loaded");
    var e = function e(r) {
        var e,
          t = new Float64Array(16);
        if (r) for (e = 0; e < r.length; e++) t[e] = r[e];
        return t;
      },
      t = e(),
      n = e([1]),
      o = e([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]),
      i = e([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function a(r) {
      var e, t;
      for (t = 0; t < 16; t++) r[t] += 65536, e = Math.floor(r[t] / 65536), r[(t + 1) * (t < 15 ? 1 : 0)] += e - 1 + 37 * (e - 1) * (15 === t ? 1 : 0), r[t] -= 65536 * e;
    }
    function f(r, e, t) {
      for (var n, o = ~(t - 1), i = 0; i < 16; i++) n = o & (r[i] ^ e[i]), r[i] ^= n, e[i] ^= n;
    }
    function c(r, e, t) {
      var n;
      for (n = 0; n < 16; n++) r[n] = e[n] + t[n] | 0;
    }
    function s(r, e, t) {
      var n;
      for (n = 0; n < 16; n++) r[n] = e[n] - t[n] | 0;
    }
    function u(r, e, t) {
      var n,
        o,
        i = new Float64Array(31);
      for (n = 0; n < 31; n++) i[n] = 0;
      for (n = 0; n < 16; n++) for (o = 0; o < 16; o++) i[n + o] += e[n] * t[o];
      for (n = 0; n < 15; n++) i[n] += 38 * i[n + 16];
      for (n = 0; n < 16; n++) r[n] = i[n];
      a(r), a(r);
    }
    function h(r, e) {
      u(r, e, e);
    }
    function l(r, t) {
      var n,
        o,
        i,
        c = e(),
        s = e();
      for (n = 0; n < 16; n++) s[n] = t[n];
      for (a(s), a(s), a(s), o = 0; o < 2; o++) {
        for (c[0] = s[0] - 65517, n = 1; n < 15; n++) c[n] = s[n] - 65535 - (c[n - 1] >> 16 & 1), c[n - 1] &= 65535;
        c[15] = s[15] - 32767 - (c[14] >> 16 & 1), i = c[15] >> 16 & 1, c[14] &= 65535, f(s, c, 1 - i);
      }
      for (n = 0; n < 16; n++) r[2 * n] = 255 & s[n], r[2 * n + 1] = s[n] >> 8;
    }
    function y(r, e) {
      var t = new Uint8Array(32),
        n = new Uint8Array(32);
      return l(t, r), l(n, e), function (r, e, t, n, o) {
        var i,
          a = 0;
        for (i = 0; i < o; i++) a |= r[e + i] ^ t[n + i];
        return (1 & a - 1 >>> 8) - 1;
      }(t, 0, n, 0, 32);
    }
    function p(r, a) {
      var f,
        p,
        d = e(),
        b = e(),
        v = e(),
        g = e(),
        w = e(),
        A = e(),
        m = e();
      return function (r, e) {
        var t;
        for (t = 0; t < 16; t++) r[t] = 0 | e[t];
      }(r[2], n), function (r, e) {
        var t;
        for (t = 0; t < 16; t++) r[t] = e[2 * t] + (e[2 * t + 1] << 8);
        r[15] &= 32767;
      }(r[1], a), h(v, r[1]), u(g, v, o), s(v, v, r[2]), c(g, r[2], g), h(w, g), h(A, w), u(m, A, w), u(d, m, v), u(d, d, g), function (r, t) {
        var n,
          o = e();
        for (n = 0; n < 16; n++) o[n] = t[n];
        for (n = 250; n >= 0; n--) h(o, o), 1 !== n && u(o, o, t);
        for (n = 0; n < 16; n++) r[n] = o[n];
      }(d, d), u(d, d, v), u(d, d, g), u(d, d, g), u(r[0], d, g), h(b, r[0]), u(b, b, g), y(b, v) && u(r[0], r[0], i), h(b, r[0]), u(b, b, g), y(b, v) ? -1 : (f = r[0], l(p = new Uint8Array(32), f), (1 & p[0]) == a[31] >> 7 && s(r[0], t, r[0]), u(r[3], r[0], r[1]), 0);
    }
    function d(r) {
      var t = new Uint8Array(32),
        o = [e(), e(), e(), e()],
        i = e(),
        a = e();
      if (p(o, r)) return null;
      var f = o[1];
      return c(i, n, f), s(a, n, f), function (r, t) {
        var n,
          o = e();
        for (n = 0; n < 16; n++) o[n] = t[n];
        for (n = 253; n >= 0; n--) h(o, o), 2 !== n && 4 !== n && u(o, o, t);
        for (n = 0; n < 16; n++) r[n] = o[n];
      }(a, a), u(i, i, a), l(t, i), t;
    }
    function b(e) {
      var t,
        n = new Uint8Array(64),
        o = new Uint8Array(32);
      for (r.lowlevel.crypto_hash(n, e, 32), n[0] &= 248, n[31] &= 127, n[31] |= 64, t = 0; t < 32; t++) o[t] = n[t];
      for (t = 0; t < 64; t++) n[t] = 0;
      return o;
    }
    return {
      convertPublicKey: d,
      convertSecretKey: b,
      convertKeyPair: function convertKeyPair(r) {
        var e = d(r.publicKey);
        return e ? {
          publicKey: e,
          secretKey: b(r.secretKey)
        } : null;
      }
    };
  }, e.exports ? e.exports = n(i) : t.ed2curve = n(t.nacl);
});
var O = function O(r) {
    if (r.length >= 255) throw new TypeError("Alphabet too long");
    for (var e = new Uint8Array(256), t = 0; t < e.length; t++) e[t] = 255;
    for (var n = 0; n < r.length; n++) {
      var o = r.charAt(n),
        i = o.charCodeAt(0);
      if (255 !== e[i]) throw new TypeError(o + " is ambiguous");
      e[i] = n;
    }
    var a = r.length,
      f = r.charAt(0),
      c = Math.log(a) / Math.log(256),
      s = Math.log(256) / Math.log(a);
    function u(r) {
      if ("string" != typeof r) throw new TypeError("Expected String");
      if (0 === r.length) return new Uint8Array();
      var t = 0;
      if (" " !== r[t]) {
        for (var n = 0, o = 0; r[t] === f;) n++, t++;
        for (var i = (r.length - t) * c + 1 >>> 0, s = new Uint8Array(i); r[t];) {
          var u = e[r.charCodeAt(t)];
          if (255 === u) return;
          for (var h = 0, l = i - 1; (0 !== u || h < o) && -1 !== l; l--, h++) u += a * s[l] >>> 0, s[l] = u % 256 >>> 0, u = u / 256 >>> 0;
          if (0 !== u) throw new Error("Non-zero carry");
          o = h, t++;
        }
        if (" " !== r[t]) {
          for (var y = i - o; y !== i && 0 === s[y];) y++;
          for (var p = new Uint8Array(n + (i - y)), d = n; y !== i;) p[d++] = s[y++];
          return p;
        }
      }
    }
    return {
      encode: function encode(e) {
        if (e instanceof Uint8Array || (ArrayBuffer.isView(e) ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : Array.isArray(e) && (e = Uint8Array.from(e))), !(e instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (0 === e.length) return "";
        for (var t = 0, n = 0, o = 0, i = e.length; o !== i && 0 === e[o];) o++, t++;
        for (var c = (i - o) * s + 1 >>> 0, u = new Uint8Array(c); o !== i;) {
          for (var h = e[o], l = 0, y = c - 1; (0 !== h || l < n) && -1 !== y; y--, l++) h += 256 * u[y] >>> 0, u[y] = h % a >>> 0, h = h / a >>> 0;
          if (0 !== h) throw new Error("Non-zero carry");
          n = l, o++;
        }
        for (var p = c - n; p !== c && 0 === u[p];) p++;
        for (var d = f.repeat(t); p < c; ++p) d += r.charAt(u[p]);
        return d;
      },
      decodeUnsafe: u,
      decode: function decode(r) {
        var e = u(r);
        if (e) return e;
        throw new Error("Non-base" + a + " character");
      }
    };
  },
  k = function k(r) {
    return r && "object" == typeof r && "function" == typeof r.copy && "function" == typeof r.fill && "function" == typeof r.readUInt8;
  },
  M = t(function (r) {
    "function" == typeof Object.create ? r.exports = function (r, e) {
      r.super_ = e, r.prototype = Object.create(e.prototype, {
        constructor: {
          value: r,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : r.exports = function (r, e) {
      r.super_ = e;
      var t = function t() {};
      t.prototype = e.prototype, r.prototype = new t(), r.prototype.constructor = r;
    };
  }),
  K = t(function (r, e) {
    var t = Object.getOwnPropertyDescriptors || function (r) {
        for (var e = Object.keys(r), t = {}, n = 0; n < e.length; n++) t[e[n]] = Object.getOwnPropertyDescriptor(r, e[n]);
        return t;
      },
      n = /%[sdj%]/g;
    e.format = function (r) {
      if (!b(r)) {
        for (var e = [], t = 0; t < arguments.length; t++) e.push(a(arguments[t]));
        return e.join(" ");
      }
      t = 1;
      for (var o = arguments, i = o.length, f = String(r).replace(n, function (r) {
          if ("%%" === r) return "%";
          if (t >= i) return r;
          switch (r) {
            case "%s":
              return String(o[t++]);
            case "%d":
              return Number(o[t++]);
            case "%j":
              try {
                return JSON.stringify(o[t++]);
              } catch (r) {
                return "[Circular]";
              }
            default:
              return r;
          }
        }), c = o[t]; t < i; c = o[++t]) p(c) || !w(c) ? f += " " + c : f += " " + a(c);
      return f;
    }, e.deprecate = function (r, t) {
      if ("undefined" != typeof process && !0 === process.noDeprecation) return r;
      if ("undefined" == typeof process) return function () {
        return e.deprecate(r, t).apply(this, arguments);
      };
      var n = !1;
      return function () {
        if (!n) {
          if (process.throwDeprecation) throw new Error(t);
          process.traceDeprecation ? console.trace(t) : console.error(t), n = !0;
        }
        return r.apply(this, arguments);
      };
    };
    var o,
      i = {};
    function a(r, t) {
      var n = {
        seen: [],
        stylize: c
      };
      return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), y(t) ? n.showHidden = t : t && e._extend(n, t), v(n.showHidden) && (n.showHidden = !1), v(n.depth) && (n.depth = 2), v(n.colors) && (n.colors = !1), v(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = f), s(n, r, n.depth);
    }
    function f(r, e) {
      var t = a.styles[e];
      return t ? "[" + a.colors[t][0] + "m" + r + "[" + a.colors[t][1] + "m" : r;
    }
    function c(r, e) {
      return r;
    }
    function s(r, t, n) {
      if (r.customInspect && t && E(t.inspect) && t.inspect !== e.inspect && (!t.constructor || t.constructor.prototype !== t)) {
        var o = t.inspect(n, r);
        return b(o) || (o = s(r, o, n)), o;
      }
      var i = function (r, e) {
        if (v(e)) return r.stylize("undefined", "undefined");
        if (b(e)) {
          var t = "'" + JSON.stringify(e).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return r.stylize(t, "string");
        }
        if (d(e)) return r.stylize("" + e, "number");
        if (y(e)) return r.stylize("" + e, "boolean");
        if (p(e)) return r.stylize("null", "null");
      }(r, t);
      if (i) return i;
      var a = Object.keys(t),
        f = function (r) {
          var e = {};
          return r.forEach(function (r, t) {
            e[r] = !0;
          }), e;
        }(a);
      if (r.showHidden && (a = Object.getOwnPropertyNames(t)), m(t) && (a.indexOf("message") >= 0 || a.indexOf("description") >= 0)) return u(t);
      if (0 === a.length) {
        if (E(t)) {
          var c = t.name ? ": " + t.name : "";
          return r.stylize("[Function" + c + "]", "special");
        }
        if (g(t)) return r.stylize(RegExp.prototype.toString.call(t), "regexp");
        if (A(t)) return r.stylize(Date.prototype.toString.call(t), "date");
        if (m(t)) return u(t);
      }
      var w,
        x = "",
        U = !1,
        _ = ["{", "}"];
      (l(t) && (U = !0, _ = ["[", "]"]), E(t)) && (x = " [Function" + (t.name ? ": " + t.name : "") + "]");
      return g(t) && (x = " " + RegExp.prototype.toString.call(t)), A(t) && (x = " " + Date.prototype.toUTCString.call(t)), m(t) && (x = " " + u(t)), 0 !== a.length || U && 0 != t.length ? n < 0 ? g(t) ? r.stylize(RegExp.prototype.toString.call(t), "regexp") : r.stylize("[Object]", "special") : (r.seen.push(t), w = U ? function (r, e, t, n, o) {
        for (var i = [], a = 0, f = e.length; a < f; ++a) S(e, String(a)) ? i.push(h(r, e, t, n, String(a), !0)) : i.push("");
        return o.forEach(function (o) {
          o.match(/^\d+$/) || i.push(h(r, e, t, n, o, !0));
        }), i;
      }(r, t, n, f, a) : a.map(function (e) {
        return h(r, t, n, f, e, U);
      }), r.seen.pop(), function (r, e, t) {
        if (r.reduce(function (r, e) {
          return e.indexOf("\n"), r + e.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60) return t[0] + ("" === e ? "" : e + "\n ") + " " + r.join(",\n  ") + " " + t[1];
        return t[0] + e + " " + r.join(", ") + " " + t[1];
      }(w, x, _)) : _[0] + x + _[1];
    }
    function u(r) {
      return "[" + Error.prototype.toString.call(r) + "]";
    }
    function h(r, e, t, n, o, i) {
      var a, f, c;
      if ((c = Object.getOwnPropertyDescriptor(e, o) || {
        value: e[o]
      }).get ? f = c.set ? r.stylize("[Getter/Setter]", "special") : r.stylize("[Getter]", "special") : c.set && (f = r.stylize("[Setter]", "special")), S(n, o) || (a = "[" + o + "]"), f || (r.seen.indexOf(c.value) < 0 ? (f = p(t) ? s(r, c.value, null) : s(r, c.value, t - 1)).indexOf("\n") > -1 && (f = i ? f.split("\n").map(function (r) {
        return "  " + r;
      }).join("\n").substr(2) : "\n" + f.split("\n").map(function (r) {
        return "   " + r;
      }).join("\n")) : f = r.stylize("[Circular]", "special")), v(a)) {
        if (i && o.match(/^\d+$/)) return f;
        (a = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (a = a.substr(1, a.length - 2), a = r.stylize(a, "name")) : (a = a.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), a = r.stylize(a, "string"));
      }
      return a + ": " + f;
    }
    function l(r) {
      return Array.isArray(r);
    }
    function y(r) {
      return "boolean" == typeof r;
    }
    function p(r) {
      return null === r;
    }
    function d(r) {
      return "number" == typeof r;
    }
    function b(r) {
      return "string" == typeof r;
    }
    function v(r) {
      return void 0 === r;
    }
    function g(r) {
      return w(r) && "[object RegExp]" === x(r);
    }
    function w(r) {
      return "object" == typeof r && null !== r;
    }
    function A(r) {
      return w(r) && "[object Date]" === x(r);
    }
    function m(r) {
      return w(r) && ("[object Error]" === x(r) || r instanceof Error);
    }
    function E(r) {
      return "function" == typeof r;
    }
    function x(r) {
      return Object.prototype.toString.call(r);
    }
    function U(r) {
      return r < 10 ? "0" + r.toString(10) : r.toString(10);
    }
    e.debuglog = function (r) {
      if (v(o) && (o = process.env.NODE_DEBUG || ""), r = r.toUpperCase(), !i[r]) if (new RegExp("\\b" + r + "\\b", "i").test(o)) {
        var t = process.pid;
        i[r] = function () {
          var n = e.format.apply(e, arguments);
          console.error("%s %d: %s", r, t, n);
        };
      } else i[r] = function () {};
      return i[r];
    }, e.inspect = a, a.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, a.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      regexp: "red"
    }, e.isArray = l, e.isBoolean = y, e.isNull = p, e.isNullOrUndefined = function (r) {
      return null == r;
    }, e.isNumber = d, e.isString = b, e.isSymbol = function (r) {
      return "symbol" == typeof r;
    }, e.isUndefined = v, e.isRegExp = g, e.isObject = w, e.isDate = A, e.isError = m, e.isFunction = E, e.isPrimitive = function (r) {
      return null === r || "boolean" == typeof r || "number" == typeof r || "string" == typeof r || "symbol" == typeof r || void 0 === r;
    }, e.isBuffer = k;
    var _ = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    function T() {
      var r = new Date(),
        e = [U(r.getHours()), U(r.getMinutes()), U(r.getSeconds())].join(":");
      return [r.getDate(), _[r.getMonth()], e].join(" ");
    }
    function S(r, e) {
      return Object.prototype.hasOwnProperty.call(r, e);
    }
    e.log = function () {
      console.log("%s - %s", T(), e.format.apply(e, arguments));
    }, e.inherits = M, e._extend = function (r, e) {
      if (!e || !w(e)) return r;
      for (var t = Object.keys(e), n = t.length; n--;) r[t[n]] = e[t[n]];
      return r;
    };
    var O = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
    function K(r, e) {
      if (!r) {
        var t = new Error("Promise was rejected with a falsy value");
        t.reason = r, r = t;
      }
      return e(r);
    }
    e.promisify = function (r) {
      if ("function" != typeof r) throw new TypeError('The "original" argument must be of type Function');
      if (O && r[O]) {
        var e;
        if ("function" != typeof (e = r[O])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(e, O, {
          value: e,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), e;
      }
      function e() {
        for (var e, t, n = new Promise(function (r, n) {
            e = r, t = n;
          }), o = [], i = 0; i < arguments.length; i++) o.push(arguments[i]);
        o.push(function (r, n) {
          r ? t(r) : e(n);
        });
        try {
          r.apply(this, o);
        } catch (r) {
          t(r);
        }
        return n;
      }
      return Object.setPrototypeOf(e, Object.getPrototypeOf(r)), O && Object.defineProperty(e, O, {
        value: e,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(e, t(r));
    }, e.promisify.custom = O, e.callbackify = function (r) {
      if ("function" != typeof r) throw new TypeError('The "original" argument must be of type Function');
      function e() {
        for (var e = [], t = 0; t < arguments.length; t++) e.push(arguments[t]);
        var n = e.pop();
        if ("function" != typeof n) throw new TypeError("The last argument must be of type Function");
        var o = this,
          i = function i() {
            return n.apply(o, arguments);
          };
        r.apply(this, e).then(function (r) {
          process.nextTick(i, null, r);
        }, function (r) {
          process.nextTick(K, r, i);
        });
      }
      return Object.setPrototypeOf(e, Object.getPrototypeOf(r)), Object.defineProperties(e, t(r)), e;
    };
  }),
  j = {
    TextEncoder: "undefined" != typeof TextEncoder ? TextEncoder : K.TextEncoder,
    TextDecoder: "undefined" != typeof TextDecoder ? TextDecoder : K.TextDecoder
  };
var B = j.TextEncoder,
  D = j.TextDecoder,
  z = new D(),
  P = new B();
var R = {
  decodeText: function decodeText(r) {
    return z.decode(r);
  },
  encodeText: function encodeText(r) {
    return P.encode(r);
  },
  concat: function concat(r, e) {
    var t = new Uint8Array(e);
    var n = 0;
    var _iterator = _createForOfIteratorHelper(r),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _e2 = _step.value;
        t.set(_e2, n), n += _e2.length;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return t;
  }
};
var L = R.encodeText;
var C = /*#__PURE__*/function () {
  function C(r, e, t, n) {
    _classCallCheck(this, C);
    this.name = r, this.code = e, this.codeBuf = L(this.code), this.alphabet = n, this.codec = t(n);
  }
  _createClass(C, [{
    key: "encode",
    value: function encode(r) {
      return this.codec.encode(r);
    }
  }, {
    key: "decode",
    value: function decode(r) {
      var _iterator2 = _createForOfIteratorHelper(r),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _e3 = _step2.value;
          if (this.alphabet && this.alphabet.indexOf(_e3) < 0) throw new Error("invalid character '".concat(_e3, "' in '").concat(r, "'"));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return this.codec.decode(r);
    }
  }]);
  return C;
}();
var N = {
  rfc4648: function rfc4648(r) {
    return function (e) {
      return {
        encode: function encode(t) {
          return function (r, e, t) {
            var n = "=" === e[e.length - 1],
              o = (1 << t) - 1;
            var i = "",
              a = 0,
              f = 0;
            for (var _n = 0; _n < r.length; ++_n) for (f = f << 8 | r[_n], a += 8; a > t;) a -= t, i += e[o & f >> a];
            if (a && (i += e[o & f << t - a]), n) for (; i.length * t & 7;) i += "=";
            return i;
          }(t, e, r);
        },
        decode: function decode(t) {
          return function (r, e, t) {
            var n = {};
            for (var _r = 0; _r < e.length; ++_r) n[e[_r]] = _r;
            var o = r.length;
            for (; "=" === r[o - 1];) --o;
            var i = new Uint8Array(o * t / 8 | 0);
            var a = 0,
              f = 0,
              c = 0;
            for (var _e4 = 0; _e4 < o; ++_e4) {
              var _o = n[r[_e4]];
              if (void 0 === _o) throw new SyntaxError("Invalid character " + r[_e4]);
              f = f << t | _o, a += t, a >= 8 && (a -= 8, i[c++] = 255 & f >> a);
            }
            if (a >= t || 255 & f << 8 - a) throw new SyntaxError("Unexpected end of data");
            return i;
          }(t, e, r);
        }
      };
    };
  }
};
var F = N.rfc4648,
  Y = R.decodeText,
  I = R.encodeText,
  G = [["identity", "\0", function () {
    return {
      encode: Y,
      decode: I
    };
  }, ""], ["base2", "0", F(1), "01"], ["base8", "7", F(3), "01234567"], ["base10", "9", O, "0123456789"], ["base16", "f", F(4), "0123456789abcdef"], ["base16upper", "F", F(4), "0123456789ABCDEF"], ["base32hex", "v", F(5), "0123456789abcdefghijklmnopqrstuv"], ["base32hexupper", "V", F(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV"], ["base32hexpad", "t", F(5), "0123456789abcdefghijklmnopqrstuv="], ["base32hexpadupper", "T", F(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV="], ["base32", "b", F(5), "abcdefghijklmnopqrstuvwxyz234567"], ["base32upper", "B", F(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"], ["base32pad", "c", F(5), "abcdefghijklmnopqrstuvwxyz234567="], ["base32padupper", "C", F(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567="], ["base32z", "h", F(5), "ybndrfg8ejkmcpqxot1uwisza345h769"], ["base36", "k", O, "0123456789abcdefghijklmnopqrstuvwxyz"], ["base36upper", "K", O, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"], ["base58btc", "z", O, "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"], ["base58flickr", "Z", O, "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"], ["base64", "m", F(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"], ["base64pad", "M", F(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="], ["base64url", "u", F(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"], ["base64urlpad", "U", F(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="]],
  V = G.reduce(function (r, e) {
    return r[e[0]] = new C(e[0], e[1], e[2], e[3]), r;
  }, {}),
  q = G.reduce(function (r, e) {
    return r[e[1]] = V[e[0]], r;
  }, {});
var J = {
    names: V,
    codes: q
  },
  Z = t(function (r, e) {
    var t = R.encodeText,
      n = R.decodeText,
      o = R.concat;
    function i(r) {
      if (J.names[r]) return J.names[r];
      if (J.codes[r]) return J.codes[r];
      throw new Error("Unsupported encoding: ".concat(r));
    }
    (e = r.exports = function (r, e) {
      if (!e) throw new Error("requires an encoded Uint8Array");
      var _i = i(r),
        t = _i.name,
        a = _i.codeBuf;
      return function (r, e) {
        i(r).decode(n(e));
      }(t, e), o([a, e], a.length + e.length);
    }).encode = function (r, e) {
      var n = i(r),
        a = t(n.encode(e));
      return o([n.codeBuf, a], n.codeBuf.length + a.length);
    }, e.decode = function (r) {
      r instanceof Uint8Array && (r = n(r));
      var e = r[0];
      return ["f", "F", "v", "V", "t", "T", "b", "B", "c", "C", "h", "k", "K"].includes(e) && (r = r.toLowerCase()), i(r[0]).decode(r.substring(1));
    }, e.isEncoded = function (r) {
      if (r instanceof Uint8Array && (r = n(r)), "[object String]" !== Object.prototype.toString.call(r)) return !1;
      try {
        return i(r[0]).name;
      } catch (r) {
        return !1;
      }
    }, e.encoding = i, e.encodingFromData = function (r) {
      return r instanceof Uint8Array && (r = n(r)), i(r[0]);
    }, e.names = Object.freeze(J.names), e.codes = Object.freeze(J.codes);
  });
function H(r, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ed25519";
  return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var n, o, a, f, c;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!("ed25519" !== t)) {
            _context.next = 2;
            break;
          }
          throw Error("'".concat(t, "' type keys are not currently supported"));
        case 2:
          n = S.convertSecretKey(e);
          if (n) {
            _context.next = 5;
            break;
          }
          throw Error("could not convert key type");
        case 5:
          o = r.slice(0, 24), a = r.slice(24, 56), f = r.slice(56), c = i.box.open(f, o, a, n);
          if (c) {
            _context.next = 8;
            break;
          }
          throw Error("failed to decrypt curve25519");
        case 8:
          return _context.abrupt("return", Uint8Array.from(c));
        case 9:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
function Q(r, e) {
  var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ed25519";
  return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var n, o, a, f, c;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!("ed25519" !== t)) {
            _context2.next = 2;
            break;
          }
          throw Error("'".concat(t, "' type keys are not currently supported"));
        case 2:
          n = i.box.keyPair(), o = S.convertPublicKey(e);
          if (o) {
            _context2.next = 5;
            break;
          }
          throw Error("could not convert key type");
        case 5:
          a = i.randomBytes(24), f = i.box(r, a, o, n.secretKey), c = new Uint8Array(56 + f.byteLength);
          return _context2.abrupt("return", (c.set(new Uint8Array(a), 0), c.set(new Uint8Array(n.publicKey), 24), c.set(new Uint8Array(f), 56), Uint8Array.from(c)));
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}
function X(r) {
  var e = Z.encode("base32", r);
  return new TextDecoder().decode(e);
}
function $(r) {
  var e = Z.encode("base32", r);
  return new TextDecoder().decode(e);
}
function W(r) {
  return X(r.bytes);
}
function rr(r) {
  return $(r.bytes);
}
function er(r) {
  return s(Z.decode(r)).Data.slice(0, 32);
}
function tr(r) {
  return h(Z.decode(r)).Data.slice(0, 32);
}
function nr(r) {
  return s(r.bytes).Data.slice(0, 32);
}
var or = /*#__PURE__*/function () {
  function or(r) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ed25519";
    _classCallCheck(this, or);
    if (this.pubKey = r, this.type = e, "ed25519" !== e) throw new Error("Invalid keys type");
    this.type = e || "ed25519";
  }
  _createClass(or, [{
    key: "verify",
    value: function verify(r, e) {
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", i.sign.detached.verify(r, e, this.pubKey));
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "toString",
    value: function toString() {
      return W(this);
    }
  }, {
    key: "bytes",
    get: function get() {
      return c({
        Type: "Ed25519",
        Data: this.pubKey
      });
    }
  }, {
    key: "encrypt",
    value: function encrypt(r) {
      return Q(r, this.pubKey, this.type);
    }
  }], [{
    key: "fromString",
    value: function fromString(r) {
      var e = er(r);
      return new or(e, "ed25519");
    }
  }]);
  return or;
}();
var ir = /*#__PURE__*/function () {
  function ir(r) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ed25519";
    _classCallCheck(this, ir);
    if (this.type = e, "ed25519" !== e) throw new Error("Invalid keys type");
    this.type = e || "ed25519";
    var t = Uint8Array.from(r);
    if (32 !== t.length) throw new Error("secretKey length is invalid");
    var n = i.sign.keyPair.fromSeed(t);
    this.seed = t, this.privKey = n.secretKey, this.pubKey = n.publicKey;
  }
  _createClass(ir, [{
    key: "canSign",
    value: function canSign() {
      return !!this.privKey;
    }
  }, {
    key: "sign",
    value: function sign(r) {
      return n(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.canSign()) {
                _context4.next = 2;
                break;
              }
              throw new Error("cannot sign: no secret key available");
            case 2:
              return _context4.abrupt("return", i.sign.detached(r, this.privKey));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "public",
    get: function get() {
      return new or(this.pubKey);
    }
  }, {
    key: "bytes",
    get: function get() {
      return u({
        Type: "Ed25519",
        Data: this.privKey
      });
    }
  }, {
    key: "toString",
    value: function toString() {
      return rr(this);
    }
  }, {
    key: "decrypt",
    value: function decrypt(r) {
      return H(r, this.privKey, this.type);
    }
  }], [{
    key: "fromRawEd25519Seed",
    value: function fromRawEd25519Seed(r) {
      return new this(r, "ed25519");
    }
  }, {
    key: "fromRandom",
    value: function fromRandom() {
      var r = i.randomBytes(32);
      return this.fromRawEd25519Seed(r);
    }
  }, {
    key: "fromString",
    value: function fromString(r) {
      return new ir(tr(r), "ed25519");
    }
  }]);
  return ir;
}();
export { ir as PrivateKey, or as PublicKey, H as decrypt, Q as encrypt, nr as extractPublicKeyBytes, $ as privateKeyBytesToString, tr as privateKeyFromString, rr as privateKeyToString, er as publicKeyBytesFromString, X as publicKeyBytesToString, W as publicKeyToString };